import StripePaymentElement from './StripePaymentElement';

export default StripePaymentElement;
